import { createSelector } from "@reduxjs/toolkit";
import { State } from "../../store";

export const selectProperty = (state: State) => state.property;

export const selectPropertyError = createSelector(
  selectProperty,
  (property) => property.error
);

export const selectPropertyLoading = createSelector(
  selectProperty,
  (property) => property.loading
);

export const selectPropertyAdults = createSelector(
  selectProperty,
  (property) => property.adults
);

export const selectPropertyIniDate = createSelector(
  selectProperty,
  (property) => property.iniDate
);

export const selectPropertyEndDate = createSelector(
  selectProperty,
  (property) => property.endDate
);

export const selectHotelData = createSelector(
  selectProperty,
  (property) => property.hotelData
);

export const selectHotelId = createSelector(
  selectHotelData,
  (hotelData) => hotelData.id
);

export const selectHotelAmenitiesList = createSelector(
  selectHotelData,
  (hotelData) => hotelData.amenitiesList
);

export const selectHotelDescription = createSelector(
  selectHotelData,
  (hotelData) => hotelData.hotelDescription
);
export const selectHotelLongDescription = createSelector(
  selectHotelData,
  (hotelData) => hotelData.hotelLongDescription
);
export const selectHotelName = createSelector(
  selectHotelData,
  (hotelData) => hotelData.name
);
export const selectHotelImages = createSelector(
  selectHotelData,
  (hotelData) => hotelData.imagePathList
);
export const selectHotelType = createSelector(
  selectHotelData,
  (hotelData) => hotelData.hotelType
);
export const selectHotelRooms = createSelector(
  selectHotelData,
  (hotelData) => hotelData.roomTypeDataList
);

export const selectHotelOpinionReviews = createSelector(
  selectHotelData,
  (hotelData) => hotelData.opinionReview
);

export const selectHotelPhone = createSelector(
  selectHotelData,
  (hotelData) => hotelData.phone
);

export const selectHotelReviews = createSelector(
  selectHotelData,
  (hotelData) => hotelData.reviewList
);

export const selectHotelAddress = createSelector(
  selectHotelData,
  (hotelData) => hotelData.address
);

export const selectHotelEmail = createSelector(
  selectHotelData,
  (hotelData) => hotelData.email
);

export const selectHotelWhatsapp = createSelector(
  selectHotelData,
  (hotelData) => hotelData.whatsApp
);

export const selectHotelLatitude = createSelector(
  selectHotelData,
  (hotelData) => hotelData.latitude
);
export const selectHotelLongitude = createSelector(
  selectHotelData,
  (hotelData) => hotelData.longitude
);

export const selectHotelPriceTypeList = createSelector(
  selectHotelData,
  (hotelData) => hotelData.paidTypeList
);

export const selectCouponCodeValid = createSelector(
  selectHotelData,
  (hotelData) => hotelData.couponCodeValid
);

export const selectCouponMessage = createSelector(
  selectHotelData,
  (hotelData) => hotelData.couponMessage
);

export const selectCouponPercentDiscount = createSelector(
  selectHotelData,
  (hotelData) => hotelData.couponPercentDiscount
);

export const selectCouponQuantityDiscount = createSelector(
  selectHotelData,
  (hotelData) => hotelData.couponQuantityDiscount
);

export const selectHotelRoom = (roomId: string) =>
  createSelector(selectHotelData, (hotelData) =>
    hotelData.roomTypeDataList.find((room) => room.id === roomId)
  );

export const selectRoomImages = (roomId: string) =>
  createSelector(selectHotelRoom(roomId), (room) => room?.imagePathList);

export const selectRoomDescription = (roomId: string) =>
  createSelector(selectHotelRoom(roomId), (room) => room?.roomTypeDescription);

export const selectRoomRates = (roomId: string) =>
  createSelector(selectHotelRoom(roomId), (room) => room?.rateDataList);

export const selectRoomCurrency = (roomId: string) =>
  createSelector(selectHotelRoom(roomId), (room) => room?.currency);

export const selectRoomName = (roomId: string) =>
  createSelector(selectHotelRoom(roomId), (room) => room?.name);

export const selectRoomMaxCapacity = (roomId: string) =>
  createSelector(selectHotelRoom(roomId), (room) => room?.maxCapacity);

export const selectRoomExtras = (roomId: string) =>
  createSelector(selectHotelRoom(roomId), (room) => {
    return room?.rateDataList?.[0]?.extraList;
  });
